import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction'; // filter

import { FareTaxTypes } from './types';

// List Fare Tax
export const listFareTaxRequest = (payload: { body?: object }) =>
  action(FareTaxTypes.LIST_FARE_TAX_REQUEST, payload);

export const listFareTaxSuccess = (payload: {
  fareTaxList: any;
  totalCount: number;
}) => action(FareTaxTypes.LIST_FARE_TAX_SUCCESS, payload);

export const listFareTaxFailure = () =>
  action(FareTaxTypes.LIST_FARE_TAX_FAILURE);

// List Fare Tax Integrator
export const listFareTaxIntegratorRequest = (payload: { body?: object }) =>
  action(FareTaxTypes.LIST_FARE_TAX_INTEGRATOR_REQUEST, payload);

export const listFareTaxIntegratorSuccess = (payload: {
  fareTaxIntegratorList: any;
  totalCount: number;
}) => action(FareTaxTypes.LIST_FARE_TAX_INTEGRATOR_SUCCESS, payload);

export const listFareTaxIntegratorFailure = () =>
  action(FareTaxTypes.LIST_FARE_TAX_INTEGRATOR_FAILURE);

// Get Fare Tax
export const getFareTaxRequest = (payload: object) =>
  action(FareTaxTypes.GET_FARE_TAX_REQUEST, payload);

export const getFareTaxSuccess = (payload: { fareTaxData: any }) =>
  action(FareTaxTypes.GET_FARE_TAX_SUCCESS, payload);

export const getFareTaxFailure = () =>
  action(FareTaxTypes.GET_FARE_TAX_FAILURE);

// Get Fare Tax Integrator
export const getFareTaxIntegratorRequest = (payload: object) =>
  action(FareTaxTypes.GET_FARE_TAX_INTEGRATOR_REQUEST, payload);

export const getFareTaxIntegratorSuccess = (payload: {
  fareTaxIntegratorData: any;
}) => action(FareTaxTypes.GET_FARE_TAX_INTEGRATOR_SUCCESS, payload);

export const getFareTaxIntegratorFailure = () =>
  action(FareTaxTypes.GET_FARE_TAX_INTEGRATOR_FAILURE);

// Get Fare Tax
export const filterFareTaxRequest = (payload: object) =>
  asyncAction(FareTaxTypes.FILTER_FARE_TAX_REQUEST, payload);

export const filterFareTaxSuccess = (payload: {
  fareTaxList: any;
  totalCount: number;
}) => action(FareTaxTypes.FILTER_FARE_TAX_SUCCESS, payload);

export const filterFareTaxFailure = () =>
  action(FareTaxTypes.FILTER_FARE_TAX_FAILURE);

// Create Fare Tax
export const createFareTaxRequest = (payload: object) =>
  action(FareTaxTypes.CREATE_FARE_TAX_REQUEST, payload);

export const createFareTaxSuccess = (payload: { fareTaxData: any }) =>
  action(FareTaxTypes.CREATE_FARE_TAX_SUCCESS, payload);

export const createFareTaxFailure = () =>
  action(FareTaxTypes.CREATE_FARE_TAX_FAILURE);

// Create Fare Tax Integrator
export const createFareTaxIntegratorRequest = (payload: object) =>
  action(FareTaxTypes.CREATE_FARE_TAX_INTEGRATOR_REQUEST, payload);

export const createFareTaxIntegratorSuccess = (payload: {
  fareTaxIntegratorData: any;
}) => action(FareTaxTypes.CREATE_FARE_TAX_INTEGRATOR_SUCCESS, payload);

export const createFareTaxIntegratorFailure = () =>
  action(FareTaxTypes.CREATE_FARE_TAX_INTEGRATOR_FAILURE);

// Update Fare Tax
export const updateFareTaxRequest = (payload: object) =>
  action(FareTaxTypes.UPDATE_FARE_TAX_REQUEST, payload);

export const updateFareTaxSuccess = (payload: { fareTaxData: any }) =>
  action(FareTaxTypes.UPDATE_FARE_TAX_SUCCESS, payload);

export const updateFareTaxFailure = () =>
  action(FareTaxTypes.UPDATE_FARE_TAX_FAILURE);

// Update Fare Tax Integrator
export const updateFareTaxIntegratorRequest = (payload: object) =>
  action(FareTaxTypes.UPDATE_FARE_TAX_INTEGRATOR_REQUEST, payload);

export const updateFareTaxIntegratorSuccess = (payload: {
  fareTaxIntegratorData: any;
}) => action(FareTaxTypes.UPDATE_FARE_TAX_INTEGRATOR_SUCCESS, payload);

export const updateFareTaxIntegratorFailure = () =>
  action(FareTaxTypes.UPDATE_FARE_TAX_INTEGRATOR_FAILURE);

// Delete Fare Tax
export const deleteFareTaxRequest = (payload: object) =>
  action(FareTaxTypes.DELETE_FARE_TAX_REQUEST, payload);

export const deleteFareTaxSuccess = () =>
  action(FareTaxTypes.DELETE_FARE_TAX_SUCCESS);

export const deleteFareTaxFailure = () =>
  action(FareTaxTypes.DELETE_FARE_TAX_FAILURE);

// Delete Fare Tax Integrator
export const deleteFareTaxIntegratorRequest = (payload: object) =>
  action(FareTaxTypes.DELETE_FARE_TAX_INTEGRATOR_REQUEST, payload);

export const deleteFareTaxIntegratorSuccess = () =>
  action(FareTaxTypes.DELETE_FARE_TAX_INTEGRATOR_SUCCESS);

export const deleteFareTaxIntegratorFailure = () =>
  action(FareTaxTypes.DELETE_FARE_TAX_INTEGRATOR_FAILURE);
